var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"change":_vm.onChange}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Job Title")]),_vm._l((_vm.jobs),function(job){return _c('option',{key:job,domProps:{"value":job}},[_vm._v(_vm._s(job))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }